import React from 'react';
import { services } from '../mock';
import AnimatedLaundryIcon from './AnimatedLaundryIcon';

const Services = () => {
  return (
    <section id="services" className="py-16 lg:py-24 bg-white relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[color:var(--brand-50)] opacity-50 blur-3xl pointer-events-none" aria-hidden="true" />
      <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-[color:var(--brand-50)] opacity-40 blur-3xl pointer-events-none" aria-hidden="true" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center mb-12 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">Layanan Kami</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Layanan <span className="text-[color:var(--brand)]">Trust Me Laundry</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {services.map((s, idx) => (
            <div
              key={s.name}
              className="service-card group reveal"
              style={{ transitionDelay: `${idx * 50}ms` }}
            >
              <div className="aspect-square bg-gradient-to-br from-[color:var(--brand-50)] to-white p-6 sm:p-8 relative">
                <div className="w-full h-full transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                  <AnimatedLaundryIcon name={s.name} />
                </div>
              </div>
              <div className="p-4 sm:p-5 text-center border-t border-[color:var(--brand-50)]">
                <div className="font-display font-bold text-[color:var(--ink)] text-[15px] sm:text-base group-hover:text-[color:var(--brand)] transition-colors">
                  {s.name}
                </div>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-1 bg-[color:var(--brand)] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
